import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

export default function setBannersLinha() {
  const sections = document.querySelectorAll('[data-banner-linha]');

  sections.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const nextEl = section.querySelector('.swiper-button-next');
    const prevEl = section.querySelector('.swiper-button-prev');

    new Swiper(carousel, {
      modules: [Pagination, Navigation],
      slidesPerView: 1.5,
      spaceBetween: 8,
      watchOverflow: true,
      speed: 1000,
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 0,
        },
      },
    });
  });
}
